//-------- Items on cart -------- //

let url = window.Shopify.routes.root + 'cart.js';
fetch(url).then(response =>
	response.json().then(data => ({
		data: data,
		status: response.status
	})
	).then(res => {
		const cart = res.data.total_price / 100;
		localStorage.setItem('CentsDonations_total', cart);
	}));


// -------- Post transaction on database -------- //

function centsDonations() {
	var date = localStorage.getItem('CentsDonations_date');
	var api = localStorage.getItem('CentsDonations_api');
	var payment = localStorage.getItem('CentsDonations_payment');

	let now = new Date();
    let month = now.getMonth() + 1;
    let today = now.getDate() + '/' + month + '/' + now.getFullYear();
  
	if (date === null || date !== today) {
		console.log('****date null or != today');
		localStorage.clear();
		console.log('****clear');
		postRequest();
		console.log('****post');
	} else if (date === today) {
		console.log('****date === today');
		if (payment) {
			console.log('****payment');
			return;
		} else if (api === undefined || api === null || api === 0 || !api) {
			console.log('****api null -> post');
			postRequest();
		} else if (api) {
			console.log('****patch');
			patchRequest();
		};
	};
};
centsDonations();

function postRequest() {
	let now = new Date();
    let month = now.getMonth() + 1;
    let today = now.getDate() + '/' + month + '/' + now.getFullYear();
    let response;
	localStorage.setItem('CentsDonations_date', today);
	fetch('https://apicents.directus.app/items/orders', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer kv7BzbS5-uBJbL9uiIC3qNSkfg3k6C9C'
		},
		body: JSON.stringify({
			website: "dafne",
			date: localStorage.getItem('CentsDonations_date') || null,
			orderValue: localStorage.getItem('CentsDonations_total') || null,
			charity: "Fondazione Pangea Onlus",
		})
	})
		.then(res => res.json())
        .then(res => response = JSON.stringify(res))
		.catch(error => console.log(error))
        .finally(() => {
          const calcolateId = response.indexOf("\"id\":");
          const startId = calcolateId + 5;
          localStorage.setItem('CentsDonations_api', response.substr(startId).split(',')[0]);
		})
};


function patchRequest() {
	let now = new Date();
	fetch('https://apicents.directus.app/items/orders/' + localStorage.getItem('CentsDonations_api'), {
		method: 'PATCH',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer kv7BzbS5-uBJbL9uiIC3qNSkfg3k6C9C'
		},
		body: JSON.stringify({
			id: localStorage.getItem('CentsDonations_api'),
			website: "dafne",
			date_updated: now,
			orderValue: localStorage.getItem('CentsDonations_total') || null,
			charity: "Fondazione Pangea Onlus",
		})
	})
		.then(res => res.json())
		.then(data => console.log(data))
		.catch(error => console.log(error))
};